/*
 * @Author: hujingyang
 * @Date: 2021-02-01 10:29:21
 * @Description:
 * @LastEditors: Do not edit
 * @LastEditTime: 2021-02-01 10:38:59
 * @FilePath: \DouYinStore\src\components\ParagraphTitle\index.tsx
 * @IDE: Created by VScode.
 */
import React from 'react';
import styles from './index.module.scss';

/**
 * 段落标题格式化组件
 * @param title  主标题(必选)
 * @param subtitle 副标题(可选)
 */
const ParagraphTitle = ({ title, subtitle }: { title: string; subtitle?: string }): JSX.Element => {
  return (
    <section className={styles.mainBox}>
      <div className={styles.title}>{title}</div>
      {
        !!subtitle && <div className={styles.subtitle}>{subtitle}</div>
      }
    </section>
  );
};
export default ParagraphTitle;
